import api from '../backend-api.js';
// import moment from "moment";
export default {
    getAllUsers: async () => {
        return (await api.getData('/user')).data
    },
    createUser: async (newUser) => {
        await api.postData('/user', newUser);
    },
    deleteUser: async (user) => {
        return api.deleteData('/user/' + user.id);
    },
    updateUser: async (user) => {
        return api.putData('/user/' + user.id, user);
    },
    getAllFacilities: async () => {
        return (await api.getData('/facilities')).data;
    },
    getBalance: async ({ userId, startDate, endDate, facilityIds }) => {
        return (await api.getData(`/communities/patrons/solde/${userId}?start_date=${startDate}&end_date=${endDate}&facilities=${facilityIds}`)).data;
    },
    getBalancesByCommunity: async ({ communityId, startDate, endDate }) => {
        console.log("Get balances for community", communityId, " from ", startDate, " to ", endDate)
        return (await api.getData(`/communities/${communityId}/patrons/solde?start_date=${startDate}&end_date=${endDate}`)).data;
    },
    getPatronOperations: async ({ patronId, startDate, endDate }) => {
        console.log("Get operations for patron ", patronId, " from ", startDate, " to ", endDate)
        return (await api.getData(`/operations/patron/${patronId}?start_date=${startDate}&end_date=${endDate}`)).data;
    },
    getPatronSales: async ({ patronId, startDate, endDate }) => {
        console.log("Get sales for patron ", patronId, " from ", startDate, " to ", endDate)
        return (await api.getData(`/sale/patron/${patronId}?start_date=${startDate}&end_date=${endDate}`)).data;
    },
};
